import { useContext } from 'react';
import { MyContext } from '../ProviderContext/ProviderContext';

const useData = () => {
	return useContext(MyContext);
};

export default useData;
